"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MirrorSelect = exports.Multiselect = exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Custom select UI.
 *
 * @class Multiselect
 * @todo ideally separate Multiselect class should be replaced completely with MirrorSelect, and just 
 * make it as a custom MirrorSelect which disables specific MirrorSelect features by default...
 * It should look something like this:
  
  class Multiselect extends MirrorSelect {
    constructor(selectElement, settings = {}) {
      const legacySettings = {
        baseClassName: 'multiselect-',
        mirrorNative: false,
        cloneAttributesWhitelist: [],
        setCssProperties: false,
        ...settings,
      };
      super(selectElement, legacySettings);
    }
  }

 * ...Or just make Multiselect and MirrorSelect the same object. Those are the default values for these 
 * settings anyway, so they can be used 1===1. There's no reason they actually need to be different, other 
 * than the fact that Multiselect is already in use, MirrorSelect is new and untried.

 * ...And that's it. That's the whole Multiselect class. But because it would also be nice to field test 
 * MirrorSelect a little bit in production before replacing the old MultiSelect, the vanilla MultiSelect 
 * exists here still in it's original form... But please get rid of the two different codes ASAP and just 
 * maintain the MirrorSelect, as soon as it has been established that MirrorSelect is ready.
 */
var Multiselect = /*#__PURE__*/function () {
  /**
   * Create an instance of Multiselect.
   * @example
   * const settings = { listElement : { size : 12 } };
   * document.querySelector('select').forEach(select => {
   *   new Multiselect(select, settings);
   * });
   * @param {HTMLSelectElement} selectElement - Select element to replace visually.
   * @param {Object} [settings={}] - Settings object to override defaults.
   * @memberof Multiselect
   */
  function Multiselect(selectElement) {
    var _selectElement$option, _selectElement$option2;

    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, Multiselect);
    this.selectElement = selectElement;
    this.settings = {
      containerElement: _objectSpread({
        className: 'multiselect-container'
      }, settings.containerElement || {}),
      buttonElement: _objectSpread({
        idPrefix: 'multiselect',
        className: 'multiselect-button',
        // Used for styling
        placeholderClassName: 'placeholder',
        textContent: !((_selectElement$option = selectElement.options[0]) !== null && _selectElement$option !== void 0 && _selectElement$option.value) && ((_selectElement$option2 = selectElement.options[0]) === null || _selectElement$option2 === void 0 ? void 0 : _selectElement$option2.textContent) || '',
        showPlaceholder: true,
        preventScrollOnFocus: false
      }, settings.buttonElement || {}),
      innerContainerElement: _objectSpread({
        className: 'multiselect-inner-container'
      }, settings.innerContainerElement || {}),
      labelElement: _objectSpread({
        idPrefix: 'multiselect-label',
        // Used to generate ID, if label doesn't have one
        className: 'multiselect-label',
        disabledClassName: 'disabled'
      }, settings.labelElement || {}),
      listElement: _objectSpread({
        className: 'multiselect-list',
        multipleClassName: 'multiple',
        size: selectElement.size || 8,
        // Number of options to show at once
        preventScrollOnFocus: true
      }, settings.listElement || {}),
      listItemElement: _objectSpread({
        idPrefix: 'multiselect-option',
        className: 'multiselect-option',
        focusClassName: 'focus',
        selectedClassName: 'selected',
        disabledClassName: 'disabled'
      }, settings.listItemElement || {}),
      listGroupElement: _objectSpread({
        className: 'multiselect-group'
      }, settings.listGroupElement || {}),
      listGroupListElement: _objectSpread({
        className: 'multiselect-group-list',
        disabledClassName: 'disabled'
      }, settings.listGroupListElement || {})
    };
    this.state = {
      isOptionsListOpen: false,
      focusedOptionsListItem: undefined,
      isItemHeightCSSVariableSet: false
    };
    this.initCustomSelectUI();
  }
  /**
   * Create a custom select to replace the native select, and mirror events and mutations between them.
   *
   * @memberof Multiselect
   */


  (0, _createClass2["default"])(Multiselect, [{
    key: "initCustomSelectUI",
    value: function initCustomSelectUI() {
      var _this = this;

      // Hidden form controls cannot be required
      if (this.selectElement.hasAttribute('required')) {
        this.selectElement.removeAttribute('required');
      } // Hide native select


      this.toggleVisibility(this.selectElement, true);
      this.selectElement.tabIndex = -1; // Get label associated with the select element

      this.labelElement = this.getAssociatedLabel(this.selectElement); // Create a container for the custom select

      this.containerElement = this.createContainerElement(); // Setup label element, if one was found

      if (this.labelElement) {
        this.setupLabelElement();
      } // Move select element into the container


      this.containerElement.appendChild(this.selectElement); // Create custom select, and point label for-attribute to the button

      this.buttonElement = this.createButtonElement();

      if (this.labelElement) {
        this.labelElement.htmlFor = this.buttonElement.id;
      }

      this.optionsListElement = this.createOptionsListElement();
      this.optionsListItemElements = [];
      this.optionsListGroupElements = {};
      this.createOptionsListItemElements(); // Get option list item height, and set it as a CSS variable to option list
      // Then multiply with option list size to get option list max height

      this.setItemHeightCSSVariable(); // Listen to native select changes, and update custom select, if event not dispatched by the multiselect itself

      this.selectElement.addEventListener('change', function (_ref) {
        var _ref$detail = _ref.detail;
        _ref$detail = _ref$detail === void 0 ? {} : _ref$detail;
        var dispatcher = _ref$detail.dispatcher;

        if (dispatcher !== 'multiselect') {
          _this.onSelectElementChange();
        }
      }); // Update custom select after(!) form reset, if native select belongs to one

      if (this.selectElement.form) {
        this.selectElement.form.addEventListener('reset', function () {
          setTimeout(function () {
            _this.onSelectElementChange();
          });
        });
      } // Listen to native select attribute and child list mutations


      this.observeSelectElementMutations(); // Add document click event listener, to close options list, if open and clicked outside of it

      document.addEventListener('click', function (_ref2) {
        var target = _ref2.target;
        return _this.onDocumentClick(target);
      });
    }
    /**
     * Create a container element, to later wrap the native and custom select elements in.
     *
     * @return {HTMLDivElement} - Container element.
     * @memberof Multiselect
     */

  }, {
    key: "createContainerElement",
    value: function createContainerElement() {
      var _this2 = this;

      var containerElement = document.createElement('div');
      containerElement.classList.add(this.settings.containerElement.className); // Listen to keydown event for keyboard navigation

      containerElement.addEventListener('keydown', function (event) {
        return _this2.onContainerElementKeydown(event);
      }); // Use label element as reference node, if available, in case label wraps the select element

      var referenceNode = this.labelElement || this.selectElement;
      referenceNode.parentNode.insertBefore(containerElement, referenceNode.nextSibling);
      return containerElement;
    }
    /**
     * Setup label element for the custom select.
     *
     * @memberof Multiselect
     */

  }, {
    key: "setupLabelElement",
    value: function setupLabelElement() {
      if (!this.labelElement.id) {
        this.labelElement.id = this.getUniqueElementId("".concat(this.settings.labelElement.idPrefix, "-").concat(this.selectElement.id || this.selectElement.name));
      }

      if (this.settings.labelElement.className) {
        this.labelElement.classList.add(this.settings.labelElement.className);
      }

      if (this.selectElement.disabled) {
        this.labelElement.classList.add(this.settings.labelElement.disabledClassName);
      } // Move label inside the container


      this.containerElement.appendChild(this.labelElement);
    }
    /**
     * Create a button element to essentially replace the UI of the native select element.
     *
     * @return {HTMLButtonElement}
     * @memberof Multiselect
     */

  }, {
    key: "createButtonElement",
    value: function createButtonElement() {
      var _this3 = this;

      var buttonElement = document.createElement('button'),
          innerContainerElement = document.createElement('div'); // Set type to "button", to not submit form if contained by one

      buttonElement.type = 'button'; // Create and set an ID for the button

      var buttonElementId = this.getUniqueElementId("".concat(this.settings.buttonElement.idPrefix, "-").concat(this.selectElement.id || this.selectElement.name));
      buttonElement.id = buttonElementId;
      buttonElement.classList.add(this.settings.buttonElement.className);
      innerContainerElement.classList.add(this.settings.innerContainerElement.className);
      buttonElement.setAttribute('aria-haspopup', 'listbox'); // If an label exists, indicate that it labels the button too

      if (this.labelElement) {
        buttonElement.setAttribute('aria-labelledby', "".concat(this.labelElement.id, " ").concat(buttonElementId));
      } // Match disabled attribute of native select


      buttonElement.disabled = this.selectElement.disabled; // Set button text content from the settings

      var spanElement = document.createElement('span');
      var textNode = document.createTextNode(this.settings.buttonElement.showPlaceholder ? this.settings.buttonElement.textContent : '');
      spanElement.appendChild(textNode);
      buttonElement.appendChild(spanElement);
      buttonElement.setAttribute('data-placeholder', this.settings.buttonElement.textContent);
      buttonElement.addEventListener('click', function () {
        return _this3.onButtonElementClick();
      }); // Insert inner container just after the select, and insert button in it

      this.containerElement.insertBefore(innerContainerElement, this.selectElement.nextSibling);
      innerContainerElement.appendChild(buttonElement);
      return buttonElement;
    }
    /**
     * Create an unordered list element for the options of the custom select.
     *
     * @return {HTMLUListElement}
     * @memberof Multiselect
     */

  }, {
    key: "createOptionsListElement",
    value: function createOptionsListElement() {
      var _this4 = this;

      var optionsListElement = document.createElement('ul');
      optionsListElement.classList.add(this.settings.listElement.className);

      if (this.selectElement.multiple) {
        optionsListElement.classList.add(this.settings.listElement.multipleClassName);
      } // Set option list hidden at first


      this.toggleVisibility(optionsListElement, true); // Enable programmatical focusability

      optionsListElement.tabIndex = -1;
      optionsListElement.setAttribute('role', 'listbox'); // Set option list labelled by the label element, if one exists

      if (this.labelElement) {
        optionsListElement.setAttribute('aria-labelledby', this.labelElement.id);
      } // Set size as a CSS variable, to later calculate option list max height


      optionsListElement.style.setProperty('--list-size', this.settings.listElement.size); // Add event listeners

      optionsListElement.addEventListener('click', function (_ref3) {
        var target = _ref3.target;
        return _this4.onOptionsListElementClick(target);
      });
      optionsListElement.addEventListener('blur', function (_ref4) {
        var relatedTarget = _ref4.relatedTarget;
        return _this4.onOptionsListElementBlur(relatedTarget);
      });
      optionsListElement.addEventListener('mouseover', function (event) {
        return _this4.onOptionsListElementMouseover(event);
      }); // Insert option list just after the button

      this.buttonElement.parentNode.insertBefore(optionsListElement, this.buttonElement.nextSibling);
      return optionsListElement;
    }
    /**
     * Create a custom option group list, to mimic an optgroup.
     *
     * @param {HTMLOptGroupElement} optgroup - Optgroup element from native select.
     * @param {referenceNode} [referenceNode=null] - Node to use as reference on insertBefore call.
     * @return {HTMLUListElement} - Option group list element.
     * @memberof Multiselect
     */

  }, {
    key: "createOptionsListGroupElement",
    value: function createOptionsListGroupElement(optgroup) {
      var referenceNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // Create a LI element to contain the group
      var listGroupElement = document.createElement('li');
      listGroupElement.setAttribute('data-group', optgroup.label);
      listGroupElement.classList.add(this.settings.listGroupElement.className); // If optgroup is hidden, set the custom group hidden too

      if (optgroup.hidden) {
        listGroupElement.hidden = true;
      } // Create an UL element to contain the group options


      var listGroupListElement = document.createElement('ul');
      listGroupListElement.classList.add(this.settings.listGroupListElement.className); // Add disabled class to the group list, if original optgroup is disabled

      if (optgroup.disabled) {
        listGroupListElement.classList.add(this.settings.listGroupListElement.disabledClassName);
      } // Copy optgroup label to title the group list element


      listGroupListElement.title = optgroup.label; // Insert option group to the dropdown

      listGroupElement.appendChild(listGroupListElement);
      this.optionsListElement.insertBefore(listGroupElement, referenceNode); // Save option group to class variable

      this.optionsListGroupElements[optgroup.label] = listGroupListElement;
      return listGroupListElement;
    }
    /**
     * Get optgroup by option.
     *
     * @param {HTMLOptionElement} option - Option of which optgroup to get.
     * @return {HTMLOptGroupElement|undefined} Optgroup element, or undefined if option has no optgroup.
     * @memberof Multiselect
     */

  }, {
    key: "getOptgroup",
    value: function getOptgroup(option) {
      return option.parentElement.tagName.toLowerCase() === 'optgroup' ? option.parentElement : undefined;
    }
    /**
     * Create an option list item for each option of the native select.
     *
     * @param {HTMLOptionsCollection} [options=this.selectElement.options] - Options of the native select.
     * @return {HTMLLIElement[]} - Array of LI elements to represent the options.
     * @memberof Multiselect
     */

  }, {
    key: "createOptionsListItemElements",
    value: function createOptionsListItemElements() {
      var _this5 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectElement.options;
      var listItemElements = Array.from(options).map(function (option) {
        return _this5.createOptionsListItemElement(option);
      });
      listItemElements.forEach(function (listItemElement, index) {
        // Get option index and reference node to insert list item at correct position
        var optionIndex = options[index].index,
            referenceNode = _this5.optionsListItemElements[optionIndex] || null,
            optgroup = _this5.getOptgroup(options[index]);

        if (optgroup) {
          // Get or create custom option group element
          var listGroupElement = _this5.optionsListGroupElements[optgroup.label] || _this5.createOptionsListGroupElement(optgroup, referenceNode); // Insert option list item in the correct position in the option group


          listGroupElement.insertBefore(listItemElement, referenceNode && referenceNode.parentElement.parentElement.dataset.group === optgroup.label ? referenceNode : null);
        } else {
          // Insert option list item in the correct position in the option list
          _this5.optionsListElement.insertBefore(listItemElement, referenceNode);
        } // Also insert in a specific index of the array


        _this5.optionsListItemElements.splice(optionIndex, 0, listItemElement);
      });
    }
    /**
     * Create an option list item for an option of the native select.
     *
     * @param {HTMLOptionElement} optionElement - Option of the native select.
     * @return {HTMLLIElement} - LI element to represent the option.
     * @memberof Multiselect
     */

  }, {
    key: "createOptionsListItemElement",
    value: function createOptionsListItemElement(optionElement) {
      var optionsListItemElement = document.createElement('li');
      optionsListItemElement.id = this.createOptionsListItemElementId(optionElement.value);
      optionsListItemElement.classList.add(this.settings.listItemElement.className); // Save value of the option in a data attribute

      optionsListItemElement.setAttribute('data-value', optionElement.value); // Get optgroup, if option belongs to one

      var optgroup = this.getOptgroup(optionElement); // Hide option list item, if the original option or its optgroup is hidden too

      if (optionElement.hidden || optgroup !== null && optgroup !== void 0 && optgroup.hidden) {
        this.toggleVisibility(optionsListItemElement, true);
      } // Add disabled class to list item, if necessary


      if (optionElement.disabled || optgroup !== null && optgroup !== void 0 && optgroup.disabled) {
        optionsListItemElement.classList.add(this.settings.listItemElement.disabledClassName);
      }

      optionsListItemElement.setAttribute('role', 'option'); // Copy text content from the original option to the option list item

      var textNode = document.createTextNode(optionElement.textContent);
      optionsListItemElement.appendChild(textNode); // Pre-select option, if selected attribute is present

      if (optionElement.selected) {
        if (this.selectElement.multiple) {
          this.toggleMultipleSelectOption(optionsListItemElement, true, optionElement);
        } else {
          this.state.focusedOptionsListItem = optionsListItemElement;
          this.toggleSingleSelectOption(optionsListItemElement, true);
        }
      }

      return optionsListItemElement;
    }
    /**
     * Observe attribute and child list mutations on the native select.
     *
     * @memberof Multiselect
     */

  }, {
    key: "observeSelectElementMutations",
    value: function observeSelectElementMutations() {
      var _this6 = this;

      var observer = new MutationObserver(function (mutations) {
        return _this6.onSelectElementMutation(mutations);
      });
      observer.observe(this.selectElement, {
        attributes: true,
        attributeFilter: ['disabled', 'hidden'],
        subtree: true,
        childList: true
      });
    }
    /**
     * Toggle custom select options list open and closed.
     *
     * @memberof Multiselect
     */

  }, {
    key: "onButtonElementClick",
    value: function onButtonElementClick() {
      !this.state.isOptionsListOpen ? this.openOptionsList() : this.closeOptionsList();
    }
    /**
     * Visually focus and toggle selections of option list items on click.
     *
     * @param {Object} target - Click event target.
     * @memberof Multiselect
     */

  }, {
    key: "onOptionsListElementClick",
    value: function onOptionsListElementClick(target) {
      if (target.getAttribute('role') === 'option') {
        this.focusOptionsListItem(target);

        if (this.selectElement.multiple) {
          this.toggleMultipleSelectOption(target);
        } else {
          this.toggleSingleSelectOption(target);
          this.closeOptionsList();
        }
      }
    }
    /**
     * Respond to keyboard navigation on the custom select container element.
     *
     * @param {Event} event - Keydown event.
     * @memberof Multiselect
     */

  }, {
    key: "onContainerElementKeydown",
    value: function onContainerElementKeydown(event) {
      switch (event.key) {
        case 'PageUp':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(-this.settings.listElement.size + 1), true) : this.openOptionsList();
          break;

        case 'PageDown':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(this.settings.listElement.size - 1), true) : this.openOptionsList();
          break;

        case 'Up':
        case 'ArrowUp':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(-1), true) : this.openOptionsList();
          break;

        case 'Down':
        case 'ArrowDown':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(1), true) : this.openOptionsList();
          break;

        case 'Home':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(0, 0), true) : this.openOptionsList();
          break;

        case 'End':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(0, this.optionsListItemElements.length - 1), true) : this.openOptionsList();
          break;

        case ' ':
        case 'Spacebar':
          if (this.state.isOptionsListOpen) {
            event.preventDefault();

            if (this.selectElement.multiple && this.state.focusedOptionsListItem) {
              this.toggleMultipleSelectOption(this.state.focusedOptionsListItem);
            }
          }

          break;

        case 'Enter':
        case 'Esc':
        case 'Escape':
          if (this.state.isOptionsListOpen) {
            event.preventDefault();
            this.closeOptionsList();
          }

          break;

        default:
          // TODO: Search for item to focus by input
          break;
      }
    }
    /**
     * Close options list on blur.
     *
     * @param {EventTarget} relatedTarget
     * @memberof Multiselect
     */

  }, {
    key: "onOptionsListElementBlur",
    value: function () {
      var _onOptionsListElementBlur = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(relatedTarget) {
        var elementReceivingFocus;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = relatedTarget;

                if (_context.t0) {
                  _context.next = 5;
                  break;
                }

                _context.next = 4;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    return resolve(document.activeElement);
                  });
                });

              case 4:
                _context.t0 = _context.sent;

              case 5:
                elementReceivingFocus = _context.t0;

                // Close options list only if the element receiving focus is not inside the custom select container
                if (!elementReceivingFocus || !this.containerElement.contains(elementReceivingFocus)) {
                  this.closeOptionsList();
                }

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onOptionsListElementBlur(_x) {
        return _onOptionsListElementBlur.apply(this, arguments);
      }

      return onOptionsListElementBlur;
    }()
    /**
     * Focus visually on option list item on mouseover.
     *
     * @param {Event} event - Mouseover event.
     * @param {Object} event.target - Event target.
     * @param {number} event.clientX - Horizontal coordinate in the viewport.
     * @param {number} event.clientY - Vertical coordinate in the viewport.
     * @memberof Multiselect
     */

  }, {
    key: "onOptionsListElementMouseover",
    value: function onOptionsListElementMouseover(_ref5) {
      var target = _ref5.target,
          clientX = _ref5.clientX,
          clientY = _ref5.clientY;

      if (target.getAttribute('role') === 'option') {
        // Check that mouse position actually changed
        var isClientXYChanged = clientX - (this.prevMouseEventClientX || 0) || clientY - (this.prevMouseEventClientY || 0);

        if (isClientXYChanged) {
          this.focusOptionsListItem(target);
          this.prevMouseEventClientX = clientX;
          this.prevMouseEventClientY = clientY;
        }
      }
    }
    /**
     * Close options list if it's open, and a click occurred outside of the container element.
     *
     * @param {Object} target - Click event target.
     * @memberof Multiselect
     */

  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(target) {
      if (this.state.isOptionsListOpen && !this.containerElement.contains(target)) {
        this.closeOptionsList();
      }
    }
    /**
     * Update selected options from native select to custom select on change.
     *
     * @memberof Multiselect
     */

  }, {
    key: "onSelectElementChange",
    value: function onSelectElementChange() {
      var _this7 = this;

      var selectedOptionsArray = Array.from(this.selectElement.selectedOptions);
      this.optionsListItemElements.forEach(function (listItem) {
        var isCustomOptionSelected = listItem.classList.contains(_this7.settings.listItemElement.selectedClassName),
            isNativeOptionSelected = selectedOptionsArray.some(function (_ref6) {
          var value = _ref6.value;
          return value === listItem.dataset.value;
        });

        if (isCustomOptionSelected) {
          if (!isNativeOptionSelected) {
            _this7.selectElement.multiple ? _this7.toggleMultipleSelectOption(listItem, true) : _this7.toggleSingleSelectOption(_this7.getFirstFocusableOptionsListItem(false, true), true);
          }
        } else if (isNativeOptionSelected) {
          _this7.selectElement.multiple ? _this7.toggleMultipleSelectOption(listItem, true) : _this7.toggleSingleSelectOption(listItem, true);
        }
      });
    }
    /**
     * Mirror mutations of the native select to the custom select.
     *
     * @param {MutationRecord[]} mutations
     * @memberof Multiselect
     */

  }, {
    key: "onSelectElementMutation",
    value: function onSelectElementMutation(mutations) {
      var _this8 = this;

      mutations.forEach(function (mutation) {
        var type = mutation.type,
            target = mutation.target,
            attributeName = mutation.attributeName;

        if (type === 'childList') {
          _this8.onSelectElementChildListMutation(mutation);
        } else if (type === 'attributes') {
          var targetTagName = target.tagName.toLowerCase();

          if (attributeName === 'disabled') {
            if (targetTagName === 'select') {
              _this8.onSelectElementDisabledMutation();
            } else if (targetTagName === 'option') {
              _this8.onOptionElementDisabledMutation(target);
            } else if (targetTagName === 'optgroup') {
              _this8.onOptgroupElementDisabledMutation(target);
            }
          } else if (attributeName === 'hidden') {
            if (targetTagName === 'select') {
              _this8.onSelectElementHiddenMutation();
            } else if (targetTagName === 'option') {
              _this8.onOptionElementHiddenMutation(target);
            } else if (targetTagName === 'optgroup') {
              _this8.onOptgroupElementHiddenMutation(target);
            }
          }
        }
      });
    }
    /**
     * Add or remove option list items on mutation of the child list of the native select.
     *
     * @param {MutationRecord} mutation - DOM mutation of the native select.
     * @param {NodeList} mutation.addedNodes - List of added nodes.
     * @param {NodeList} mutation.removedNodes - List of removed nodes.
     * @memberof Multiselect
     */

  }, {
    key: "onSelectElementChildListMutation",
    value: function onSelectElementChildListMutation(_ref7) {
      var _this9 = this;

      var addedNodes = _ref7.addedNodes,
          removedNodes = _ref7.removedNodes;
      var addedOptions = this.filterNodeListByConstructor(addedNodes, HTMLOptionElement),
          removedOptions = this.filterNodeListByConstructor(removedNodes, HTMLOptionElement); // If any options added to native select, also add them to custom select

      if (addedOptions.length) {
        this.createOptionsListItemElements(addedOptions);
      } // Same goes for removed options


      if (removedOptions.length) {
        removedOptions.forEach(function (removedOption) {
          var correspondingListItemIndex = _this9.optionsListItemElements.findIndex(function (_ref8) {
            var value = _ref8.dataset.value;
            return value === removedOption.value;
          });

          var correspondingListItem = _this9.optionsListItemElements[correspondingListItemIndex];

          if (correspondingListItem) {
            // If removed option was selected, unselect it from the custom select
            if (removedOption.selected) {
              if (_this9.selectElement.multiple) {
                removedOption.selected = false;

                _this9.toggleMultipleSelectOption(correspondingListItem, true, removedOption);
              } else {
                _this9.toggleSingleSelectOption(correspondingListItem, true, '');
              }
            } // Remove option list item


            correspondingListItem.parentElement.removeChild(correspondingListItem);

            _this9.optionsListItemElements.splice(correspondingListItemIndex, 1);
          }
        });
      }
    }
    /**
     * Toggle disabled state of custom select on mutation of native select disabled attribute.
     *
     * @memberof Multiselect
     */

  }, {
    key: "onSelectElementDisabledMutation",
    value: function onSelectElementDisabledMutation() {
      if (this.selectElement.disabled && this.state.isOptionsListOpen) {
        this.closeOptionsList();
      }

      if (this.labelElement) {
        if (this.selectElement.disabled) {
          this.labelElement.classList.add(this.settings.labelElement.disabledClassName);
        } else {
          this.labelElement.classList.remove(this.settings.labelElement.disabledClassName);
        }
      }

      this.buttonElement.disabled = this.selectElement.disabled;
    }
    /**
     * Toggle hidden state of custom select on mutation of native select hidden attribute.
     *
     * @memberof Multiselect
     */

  }, {
    key: "onSelectElementHiddenMutation",
    value: function onSelectElementHiddenMutation() {
      if (this.selectElement.hidden && this.state.isOptionsListOpen) {
        this.closeOptionsList();
      }

      this.containerElement.hidden = this.selectElement.hidden;
    }
    /**
     * Toggle disabled state of custom option on mutation of native option disabled attribute.
     *
     * @param {HTMLOptionElement} option - Mutated option element.
     * @memberof Multiselect
     */

  }, {
    key: "onOptionElementDisabledMutation",
    value: function onOptionElementDisabledMutation(option) {
      var optionsListItem = this.findMatchingOptionsListItem(option);

      if (option.disabled) {
        if (!optionsListItem.classList.contains(this.settings.listItemElement.disabledClassName)) {
          optionsListItem.classList.add(this.settings.listItemElement.disabledClassName);
        }
      } else if (optionsListItem.classList.contains(this.settings.listItemElement.disabledClassName)) {
        optionsListItem.classList.remove(this.settings.listItemElement.disabledClassName);
      }
    }
    /**
     * Toggle hidden state of custom option on mutation of native option hidden attribute.
     *
     * @param {HTMLOptionElement} option - Mutated option element.
     * @memberof Multiselect
     */

  }, {
    key: "onOptionElementHiddenMutation",
    value: function onOptionElementHiddenMutation(option) {
      var optionsListItem = this.findMatchingOptionsListItem(option);
      this.toggleVisibility(optionsListItem, option.hidden);
    }
    /**
     * Toggle disabled state of custom optgroup on mutation of native optgroup disabled attribute.
     *
     * @param {HTMLOptGroupElement} optgroup - Mutated optgroup element.
     * @param {string} optgroup.label - Label of optgroup.
     * @param {boolean} optgroup.disabled - Disabled attribute of optgroup.
     * @memberof Multiselect
     */

  }, {
    key: "onOptgroupElementDisabledMutation",
    value: function onOptgroupElementDisabledMutation(_ref9) {
      var _this10 = this;

      var label = _ref9.label,
          disabled = _ref9.disabled;
      var listGroup = this.optionsListGroupElements[label];

      if (disabled) {
        if (!listGroup.classList.contains(this.settings.listGroupListElement.disabledClassName)) {
          listGroup.classList.add(this.settings.listGroupListElement.disabledClassName);
        }
      } else if (listGroup.classList.contains(this.settings.listGroupListElement.disabledClassName)) {
        listGroup.classList.remove(this.settings.listGroupListElement.disabledClassName);
      }

      Array.from(listGroup.children).forEach(function (listItem) {
        if (disabled) {
          if (!listItem.classList.contains(_this10.settings.listItemElement.disabledClassName)) {
            listItem.classList.add(_this10.settings.listItemElement.disabledClassName);
          }
        } else if (listItem.classList.contains(_this10.settings.listItemElement.disabledClassName)) {
          listItem.classList.remove(_this10.settings.listItemElement.disabledClassName);
        }
      });
    }
    /**
     * Toggle hidden state of custom optgroup on mutation of native optgroup hidden attribute.
     *
     * @param {HTMLOptGroupElement} optgroup - Mutated optgroup element.
     * @param {string} optgroup.label - Label of optgroup.
     * @param {boolean} optgroup.hidden - Hidden attribute of optgroup.
     * @memberof Multiselect
     */

  }, {
    key: "onOptgroupElementHiddenMutation",
    value: function onOptgroupElementHiddenMutation(_ref10) {
      var label = _ref10.label,
          hidden = _ref10.hidden;
      this.optionsListGroupElements[label].parentElement.hidden = hidden;
      Array.from(this.optionsListGroupElements[label].children).forEach(function (listItem) {
        listItem.hidden = hidden;
      });
    }
    /**
     * Open custom select options list.
     *
     * @memberof Multiselect
     */

  }, {
    key: "openOptionsList",
    value: function openOptionsList() {
      if (!this.state.isOptionsListOpen) {
        // Set item height CSS variable, if it is not set yet
        if (!this.state.isItemHeightCSSVariableSet) {
          this.setItemHeightCSSVariable();
        }

        this.state.isOptionsListOpen = true;
        this.toggleVisibility(this.optionsListElement, false);
        this.buttonElement.setAttribute('aria-expanded', 'true');
        this.optionsListElement.focus(this.settings.listElement.preventScrollOnFocus ? {
          preventScroll: true
        } : {});

        if (this.state.focusedOptionsListItem) {
          this.optionsListElement.setAttribute('aria-activedescendant', this.state.focusedOptionsListItem.id);
        } else if (this.optionsListItemElements.length) {
          this.focusOptionsListItem(this.getFirstFocusableOptionsListItem(false, true));
        }
      }
    }
    /**
     * Close custom select options list.
     *
     * @memberof Multiselect
     */

  }, {
    key: "closeOptionsList",
    value: function closeOptionsList() {
      if (this.state.isOptionsListOpen) {
        this.state.isOptionsListOpen = false;
        this.toggleVisibility(this.optionsListElement, true);
        this.buttonElement.removeAttribute('aria-expanded');
        this.buttonElement.focus(this.settings.buttonElement.preventScrollOnFocus ? {
          preventScroll: true
        } : {});
        this.optionsListElement.removeAttribute('aria-activedescendant');

        if (this.state.focusedOptionsListItem && this.selectElement.multiple) {
          this.state.focusedOptionsListItem.classList.remove(this.settings.listItemElement.focusClassName);
          this.state.focusedOptionsListItem = undefined;
        }
      }
    }
    /**
     * Toggle selection of an option of a single-select.
     *
     * @param {Object} target - Toggled option list item.
     * @param {boolean} isPreSelect - Toggled through pre-selection ("selected" attribute).
     * @param {string} [value=target.dataset.value] - Value of option list item.
     * @return {undefined}
     * @memberof Multiselect
     */

  }, {
    key: "toggleSingleSelectOption",
    value: function toggleSingleSelectOption(target) {
      var _this11 = this;

      var isPreSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : target.dataset.value;

      if (!isPreSelect) {
        // Return if tried to toggle selected option
        if (value && value === this.selectElement.value) {
          return;
        } // Set value of the native select


        this.selectElement.value = value; // Dispatch change event

        this.selectElement.dispatchEvent(new CustomEvent('change', {
          bubbles: true,
          detail: {
            dispatcher: 'multiselect'
          }
        }));
      } // Update custom select UI depending on if the selected option has a value or not


      if (value) {
        // Show the default text content of the button above the selected options
        if (this.settings.buttonElement.showPlaceholder && !this.buttonElement.classList.contains(this.settings.buttonElement.placeholderClassName)) {
          this.buttonElement.classList.add(this.settings.buttonElement.placeholderClassName);
        } // Set selected data attribute, mainly for easier styling


        if (!this.buttonElement.hasAttribute('data-selected')) {
          this.buttonElement.setAttribute('data-selected', '');
        } // Set text content of the button to match the selected option list item


        this.buttonElement.firstElementChild.textContent = target.textContent;
        this.buttonElement.firstElementChild.setAttribute('data-label-for', target.id);
      } else {
        // Hide the "placeholder" text
        if (this.settings.buttonElement.showPlaceholder && this.buttonElement.classList.contains(this.settings.buttonElement.placeholderClassName)) {
          this.buttonElement.classList.remove(this.settings.buttonElement.placeholderClassName);
        } // Reset text content of the button to the default one


        this.buttonElement.firstElementChild.textContent = this.settings.buttonElement.showPlaceholder ? this.settings.buttonElement.textContent : target.textContent;
        this.buttonElement.removeAttribute('data-selected');
        this.buttonElement.firstElementChild.removeAttribute('data-label-for');
      } // Remove selected class and "aria-selected" attribute from previously selected option


      if (this.optionsListItemElements) {
        this.optionsListItemElements.forEach(function (listItem) {
          if (listItem.classList.contains(_this11.settings.listItemElement.selectedClassName)) {
            listItem.classList.remove(_this11.settings.listItemElement.selectedClassName);
          }

          if (listItem.hasAttribute('aria-selected')) {
            listItem.removeAttribute('aria-selected');
          }
        });
      } // Add selected class and "aria-selected" attribute on the selected option


      target.classList.add(this.settings.listItemElement.selectedClassName);
      target.setAttribute('aria-selected', 'true');
    }
    /**
     * Toggle selection of an option of a multiselect.
     *
     * @param {Object} target - Toggled option list item.
     * @param {boolean} isPreSelect - Toggled through pre-selection ("selected" attribute).
     * @param {HTMLOptionElement} [targetNativeOption=this.findMatchingNativeOption(target)] - Corresponding native option.
     * @memberof Multiselect
     */

  }, {
    key: "toggleMultipleSelectOption",
    value: function toggleMultipleSelectOption(target) {
      var isPreSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var targetNativeOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.findMatchingNativeOption(target);

      if (!isPreSelect) {
        // Toggle selection of native option
        targetNativeOption.selected = !targetNativeOption.selected; // Dispatch change event

        this.selectElement.dispatchEvent(new CustomEvent('change', {
          bubbles: true,
          detail: {
            dispatcher: 'multiselect'
          }
        }));
      } // Update custom select UI accordingly


      if (targetNativeOption.selected) {
        target.classList.add(this.settings.listItemElement.selectedClassName);
        target.setAttribute('aria-selected', 'true');

        if (target.dataset.value) {
          // Show the default text content of the button above the selected options
          if (this.settings.buttonElement.showPlaceholder && !this.buttonElement.classList.contains(this.settings.buttonElement.placeholderClassName)) {
            this.buttonElement.classList.add(this.settings.buttonElement.placeholderClassName);
          } // Reset text content of the button, if only the default value is shown


          if (this.buttonElement.firstElementChild.textContent === this.settings.buttonElement.textContent) {
            this.buttonElement.firstElementChild.textContent = '';
          } // Set selected data attribute, mainly for easier styling


          if (!this.buttonElement.hasAttribute('data-selected')) {
            this.buttonElement.setAttribute('data-selected', '');
          } // Create a span element for the selected option


          var spanElement = document.createElement('span'),
              textNode = document.createTextNode(target.textContent);
          spanElement.setAttribute('data-label-for', target.id);
          spanElement.appendChild(textNode); // Add the span element with the text content of the selected option to the button

          this.buttonElement.firstElementChild.appendChild(spanElement);
        }
      } else {
        target.classList.remove(this.settings.listItemElement.selectedClassName);
        target.removeAttribute('aria-selected'); // Find the span element that represents the unselected option

        var _spanElement = Array.from(this.buttonElement.firstElementChild.children).find(function (_ref11) {
          var labelFor = _ref11.dataset.labelFor;
          return labelFor === target.id;
        }); // Remove the matching span element, if found


        if (_spanElement) {
          this.buttonElement.firstElementChild.removeChild(_spanElement);
        } // Hide the "placeholder" text, if the last selected option was just unselected


        if (!this.buttonElement.firstElementChild.children.length) {
          if (this.settings.buttonElement.showPlaceholder && this.buttonElement.classList.contains(this.settings.buttonElement.placeholderClassName)) {
            this.buttonElement.classList.remove(this.settings.buttonElement.placeholderClassName);
          } // Reset text content of the button to the default one


          this.buttonElement.firstElementChild.textContent = this.settings.buttonElement.showPlaceholder ? this.settings.buttonElement.textContent : '';
          this.buttonElement.removeAttribute('data-selected');
        }
      }
    }
    /**
     * Set visual focus only to target option list item.
     *
     * @param {Object} target - Option list item to visually focus.
     * @param {boolean} [isTriggeredByKey=false] - Is focus triggered through keyboard nagivation.
     * @return {undefined}
     * @memberof Multiselect
     */

  }, {
    key: "focusOptionsListItem",
    value: function focusOptionsListItem(target) {
      var isTriggeredByKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!target) {
        return;
      }

      if (this.state.focusedOptionsListItem) {
        this.state.focusedOptionsListItem.classList.remove(this.settings.listItemElement.focusClassName);
      }

      this.state.focusedOptionsListItem = target;

      if (!target.classList.contains(this.settings.listItemElement.focusClassName)) {
        target.classList.add(this.settings.listItemElement.focusClassName);
      }

      if (isTriggeredByKey) {
        this.optionsListElement.setAttribute('aria-activedescendant', target.id); // Scroll to target, if it's off-screen

        this.scrollToOptionListItemElement(target); // Auto-select option on focus, in the case of a single select, and if focus is triggered by key

        if (!this.selectElement.multiple) {
          this.toggleSingleSelectOption(target);
        }
      }
    }
    /**
     * Scroll to option list item, if it's off-screen.
     *
     * @param {HTMLLIElement} listItem - Option list item of which position to check.
     * @memberof Multiselect
     */

  }, {
    key: "scrollToOptionListItemElement",
    value: function scrollToOptionListItemElement(listItem) {
      if (this.optionsListElement.scrollHeight > this.optionsListElement.clientHeight) {
        var listItemBottom = listItem.offsetTop + listItem.offsetHeight,
            scrollBottom = this.optionsListElement.clientHeight + this.optionsListElement.scrollTop;

        if (listItemBottom > scrollBottom) {
          this.optionsListElement.scrollTop = listItemBottom - this.optionsListElement.clientHeight;
        } else if (listItem.offsetTop < this.optionsListElement.scrollTop) {
          this.optionsListElement.scrollTop = listItem.offsetTop;
        }
      }
    }
    /**
     * Get a boolean value whether to visually focus on an option list item, or not.
     *
     * @return {boolean}
     * @memberof Multiselect
     */

  }, {
    key: "shouldFocusOnOption",
    value: function shouldFocusOnOption() {
      return this.state.isOptionsListOpen || !this.selectElement.multiple;
    }
    /**
     * Get closest focusable option list item by offset.
     *
     * @param {number} offset - Offset to add to index.
     * @param {number} [index=this.getFocusedOptionIndex()] - Index of option list item.
     * @return {HTMLLIElement|undefined} Closest option list item to focus, or undefined if none found.
     * @memberof Multiselect
     */

  }, {
    key: "getClosestFocusableOptionListItem",
    value: function getClosestFocusableOptionListItem(offset) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFocusedOptionIndex();
      var targetIndex = index + offset; // If target index is equal or less than 0, return first focusable option list item

      if (targetIndex <= 0) {
        return this.getFirstFocusableOptionsListItem();
      } // If target index is equal or larger than last index of array, return last focusable option list item


      if (targetIndex >= this.optionsListItemElements.length - 1) {
        return this.getLastFocusableOptionsListItem();
      } // Else if offset is falsy (0), there's nothing to do


      if (!offset) {
        return this.state.focusedOptionsListItem;
      }

      var targetOptionsListItem = this.optionsListItemElements[targetIndex]; // Check if target is hidden or disabled

      if (targetOptionsListItem.hidden || targetOptionsListItem.classList.contains(this.settings.listItemElement.disabledClassName)) {
        // If so, recursively check next or previous option list item, based on whether offset is positive or negative
        return this.getClosestFocusableOptionListItem(offset + Math.sign(offset), index);
      }

      return targetOptionsListItem;
    }
    /**
     * Get index of the visually focused option list item.
     *
     * @return {number|undefined} - Index, or undefined if no option list item is focused.
     * @memberof Multiselect
     */

  }, {
    key: "getFocusedOptionIndex",
    value: function getFocusedOptionIndex() {
      return this.state.focusedOptionsListItem && this.optionsListItemElements.indexOf(this.state.focusedOptionsListItem);
    }
    /**
     * Create an ID for the option list item.
     *
     * @param {string} value - Value of an option of the native select.
     * @return {string}
     * @memberof Multiselect
     */

  }, {
    key: "createOptionsListItemElementId",
    value: function createOptionsListItemElementId(value) {
      return this.getUniqueElementId("".concat(this.settings.listItemElement.idPrefix, "-").concat(value ? value.toLowerCase().replace(/\s/, '-') : 'empty'));
    }
    /**
     * Set option list item height to a CSS variable for the option list element.
     *
     * @return {undefined}
     * @memberof Multiselect
     */

  }, {
    key: "setItemHeightCSSVariable",
    value: function setItemHeightCSSVariable() {
      var firstListItemWithHeight = this.getFirstFocusableOptionsListItem(true, false); // Do nothing, if could not find an option list item

      if (!firstListItemWithHeight) {
        return;
      } // Unhide option list element temporarily (not visually though) to get the height of its child


      this.optionsListElement.style.height = '0';
      this.optionsListElement.style.border = '0';
      this.optionsListElement.style.overflowY = 'hidden';
      this.optionsListElement.hidden = false; // Check if list item is contained by a hidden group

      var listItemGroup = firstListItemWithHeight.parentElement.parentElement.classList.contains(this.settings.listGroupElement.className) && firstListItemWithHeight.parentElement.parentElement;
      var isListItemGroupHidden = listItemGroup === null || listItemGroup === void 0 ? void 0 : listItemGroup.hidden; // If so, unhide the group too

      if (isListItemGroupHidden) {
        listItemGroup.hidden = false;
      } // Save list item scroll height


      var listItemHeight = firstListItemWithHeight.scrollHeight; // Hide group again

      if (isListItemGroupHidden) {
        listItemGroup.hidden = true;
      } // Hide option list element again


      this.optionsListElement.hidden = true;
      this.optionsListElement.style.removeProperty('height');
      this.optionsListElement.style.removeProperty('border');
      this.optionsListElement.style.removeProperty('overflow-y'); // Do nothing, if option list item has no scroll height

      if (!listItemHeight) {
        return;
      } // Otherwise set the CSS variable


      this.optionsListElement.style.setProperty('--item-height', "".concat(listItemHeight, "px")); // Update state to not set item height CSS variable again

      this.state.isItemHeightCSSVariableSet = true;
    }
    /**
     * Get first label element associated with the select element.
     *
     * @param {HTMLSelectElement} selectElement - Native select element.
     * @param {NodeList|undefined} selectElement.labels - Label elements associated with select element.
     * @param {string} selectElement.id - ID of select element.
     * @return {HTMLLabelElement|undefined|null}
     * @memberof Multiselect
     */

  }, {
    key: "getAssociatedLabel",
    value: function getAssociatedLabel(_ref12) {
      var labels = _ref12.labels,
          id = _ref12.id;
      return labels ? labels[0] : document.querySelector("label[for=\"".concat(id, "\"]"));
    }
    /**
     * Toggle hidden and aria-hidden attributes of an element.
     *
     * @param {HTMLElement} element - Any HTML element.
     * @param {boolean} [shouldHide=!element.hidden] - Hide or show element.
     * @memberof Multiselect
     */

  }, {
    key: "toggleVisibility",
    value: function toggleVisibility(element) {
      var shouldHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !element.hidden;
      element.hidden = shouldHide;

      if (shouldHide) {
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('aria-hidden');
      }
    }
    /**
     * Get first focusable option list item.
     *
     * @param {boolean} [checkHidden=true] - Whether to check option list item class list for truthy hidden attribute.
     * @param {boolean} [checkDisabled=true] - Whether to check option list item class list for disabled class.
     * @return {HTMLLIElement|undefined} - First focusable option list item, or undefined if not found.
     * @memberof Multiselect
     */

  }, {
    key: "getFirstFocusableOptionsListItem",
    value: function getFirstFocusableOptionsListItem() {
      var _this12 = this;

      var checkHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var checkDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.optionsListItemElements.find(function (listItem) {
        return (!checkHidden || !listItem.hidden) && (!checkDisabled || !listItem.classList.contains(_this12.settings.listItemElement.disabledClassName));
      });
    }
    /**
     * Get last focusable option list item.
     *
     * @return {HTMLLIElement|undefined} - Last focusable option list item, or undefined if not found.
     * @memberof Multiselect
     */

  }, {
    key: "getLastFocusableOptionsListItem",
    value: function getLastFocusableOptionsListItem() {
      var lastFocusableListItem;

      for (var index = this.optionsListItemElements.length - 1; index >= 0; index--) {
        if (!this.optionsListItemElements[index].hidden && !this.optionsListItemElements[index].classList.contains(this.settings.listItemElement.disabledClassName)) {
          lastFocusableListItem = this.optionsListItemElements[index];
          break;
        }
      }

      return lastFocusableListItem;
    }
    /**
     * Find option from the native select that matches a given option list item.
     *
     * @param {HTMLLIElement} optionListItem - Option list item from the custom select.
     * @return {HTMLOptionElement} - Corresponding option from the native select.
     * @memberof Multiselect
     */

  }, {
    key: "findMatchingNativeOption",
    value: function findMatchingNativeOption(optionListItem) {
      return Array.from(this.selectElement.options).find(function (_ref13) {
        var value = _ref13.value;
        return value === optionListItem.dataset.value;
      });
    }
    /**
     * Find option list item that matches a given option from the native select.
     *
     * @param {HTMLOptionElement} option - Native option element.
     * @return {HTMLLIElement} - Corresponding option list item from the custom select.
     * @memberof Multiselect
     */

  }, {
    key: "findMatchingOptionsListItem",
    value: function findMatchingOptionsListItem(option) {
      return this.optionsListItemElements.find(function (_ref14) {
        var value = _ref14.dataset.value;
        return value === option.value;
      });
    }
    /**
     * Filter node list by constructor.
     *
     * @param {NodeList} nodeList - Node list to filter.
     * @param {Object} constructor - Object to test against.
     * @return {Array} - Array of filtered nodes.
     * @memberof Multiselect
     */

  }, {
    key: "filterNodeListByConstructor",
    value: function filterNodeListByConstructor(nodeList, constructor) {
      return nodeList.length ? Array.from(nodeList).filter(function (node) {
        return node instanceof constructor;
      }) : [];
    }
    /**
     * Check element ID is unique, and if not, iterate until one is found, and return the ID suffixed with index.
     *
     * @param {string} id - Element ID to test.
     * @param {number} [index=0] - Index to suffix the ID with.
     * @return {string} - Unique element ID.
     * @memberof Multiselect
     */

  }, {
    key: "getUniqueElementId",
    value: function getUniqueElementId(id) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var idToTest = index ? "".concat(id, "-").concat(index) : id;

      if (document.getElementById(idToTest)) {
        return this.getUniqueElementId(id, index + 1);
      }

      return idToTest;
    }
  }]);
  return Multiselect;
}();

exports.Multiselect = Multiselect;
var _default = Multiselect;
/**
 * Custom select UI.
 *
 * @class MirrorSelect
 */

exports["default"] = _default;

var MirrorSelect = /*#__PURE__*/function () {
  /**
   * Create an instance of MirrorSelect.
   * @example
   * const settings = { listElement : { size : 12 } };
   * document.querySelector('select').forEach(select => {
   *   new MirrorSelect(select, settings);
   * });
   * @param {HTMLSelectElement} selectElement - Select element to replace visually.
   * @param {Object} [settings={}] - Settings object to override defaults.
   * @memberof MirrorSelect
   */
  function MirrorSelect(selectElement) {
    var _selectElement$option3, _selectElement$option4;

    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, MirrorSelect);
    this.selectElement = selectElement;
    var baseClassName = settings.baseClassName || 'multiselect-';
    this.settings = {
      containerElement: _objectSpread({
        className: "".concat(baseClassName, "container"),
        classNameOpen: "".concat(baseClassName, "container--open")
      }, settings.containerElement || {}),
      buttonElement: _objectSpread({
        idPrefix: 'multiselect',
        className: "".concat(baseClassName, "button"),
        // Used for styling
        placeholderClassName: 'placeholder',
        textContent: !((_selectElement$option3 = selectElement.options[0]) !== null && _selectElement$option3 !== void 0 && _selectElement$option3.value) && ((_selectElement$option4 = selectElement.options[0]) === null || _selectElement$option4 === void 0 ? void 0 : _selectElement$option4.textContent) || '',
        showPlaceholder: true,
        preventScrollOnFocus: false
      }, settings.buttonElement || {}),
      innerContainerElement: _objectSpread({
        className: "".concat(baseClassName, "inner-container")
      }, settings.innerContainerElement || {}),
      labelElement: _objectSpread({
        idPrefix: 'multiselect-label',
        // Used to generate ID, if label doesn't have one
        className: "".concat(baseClassName, "label"),
        disabledClassName: 'disabled'
      }, settings.labelElement || {}),
      listElement: _objectSpread({
        className: "".concat(baseClassName, "list"),
        multipleClassName: 'multiple',
        size: selectElement.size || 8,
        // Number of options to show at once
        preventScrollOnFocus: true
      }, settings.listElement || {}),
      listItemElement: _objectSpread({
        idPrefix: 'multiselect-option',
        className: "".concat(baseClassName, "option"),
        focusClassName: 'focus',
        selectedClassName: 'selected',
        disabledClassName: 'disabled'
      }, settings.listItemElement || {}),
      listGroupElement: _objectSpread({
        className: "".concat(baseClassName, "group")
      }, settings.listGroupElement || {}),
      listGroupListElement: _objectSpread({
        className: "".concat(baseClassName, "group-list"),
        disabledClassName: 'disabled'
      }, settings.listGroupListElement || {}),
      mirrorNative: !!settings.mirrorNative || false,
      cloneAttributesWhitelist: settings.cloneAttributesWhitelist || [],
      setCssProperties: settings.setCssProperties || true
    };
    this.state = {
      isOptionsListOpen: false,
      focusedOptionsListItem: undefined,
      isItemHeightCSSVariableSet: false
    };
    this.initCustomSelectUI();
  }
  /**
   * Create a custom select to replace the native select, and mirror events and mutations between them.
   *
   * @memberof MirrorSelect
   */


  (0, _createClass2["default"])(MirrorSelect, [{
    key: "initCustomSelectUI",
    value: function initCustomSelectUI() {
      var _this13 = this;

      // Hidden form controls cannot be required
      if (this.selectElement.hasAttribute('required')) {
        this.selectElement.removeAttribute('required');
      } // Hide native select
      // this.toggleVisibility(this.selectElement, true);


      this.selectElement.tabIndex = -1; // Get label associated with the select element

      this.labelElement = this.getAssociatedLabel(this.selectElement); // Create a container for the custom select

      this.containerElement = this.createContainerElement(); // Setup label element, if one was found

      if (this.labelElement) {
        this.setupLabelElement();
      } // Move select element into the container


      this.containerElement.appendChild(this.selectElement); // Create custom select, and point label for-attribute to the button

      this.buttonElement = this.createButtonElement();

      if (this.labelElement) {
        this.labelElement.htmlFor = this.buttonElement.id;
      }

      this.optionsListElement = this.createOptionsListElement();
      this.optionsListItemElements = [];
      this.optionsListGroupElements = {};
      this.createOptionsListItemElements(); // Get option list item height, and set it as a CSS variable to option list
      // Then multiply with option list size to get option list max height

      this.setItemHeightCSSVariable(); // Listen to native select changes, and update custom select, if event not dispatched by the multiselect itself

      this.selectElement.addEventListener('change', function (_ref15) {
        var _ref15$detail = _ref15.detail;
        _ref15$detail = _ref15$detail === void 0 ? {} : _ref15$detail;
        var dispatcher = _ref15$detail.dispatcher;

        if (dispatcher !== 'multiselect') {
          _this13.onSelectElementChange();
        }
      }); // Update custom select after(!) form reset, if native select belongs to one

      if (this.selectElement.form) {
        this.selectElement.form.addEventListener('reset', function () {
          setTimeout(function () {
            _this13.onSelectElementChange();
          });
        });
      } // Listen to native select attribute and child list mutations


      this.observeSelectElementMutations(); // Add document click event listener, to close options list, if open and clicked outside of it

      document.addEventListener('click', function (_ref16) {
        var target = _ref16.target;
        return _this13.onDocumentClick(target);
      });
    }
    /**
     * Create a container element, to later wrap the native and custom select elements in.
     *
     * @return {HTMLDivElement} - Container element.
     * @memberof MirrorSelect
     */

  }, {
    key: "createContainerElement",
    value: function createContainerElement() {
      var _this14 = this;

      var containerElement = document.createElement('div');
      containerElement.classList.add(this.settings.containerElement.className); // Listen to keydown event for keyboard navigation

      containerElement.addEventListener('keydown', function (event) {
        return _this14.onContainerElementKeydown(event);
      }); // Use label element as reference node, if available, in case label wraps the select element

      var referenceNode = this.labelElement || this.selectElement;
      referenceNode.parentNode.insertBefore(containerElement, referenceNode.nextSibling);
      return containerElement;
    }
    /**
     * Setup label element for the custom select.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "setupLabelElement",
    value: function setupLabelElement() {
      if (!this.labelElement.id) {
        this.labelElement.id = this.getUniqueElementId("".concat(this.settings.labelElement.idPrefix, "-").concat(this.selectElement.id || this.selectElement.name));
      }

      if (this.settings.labelElement.className) {
        this.labelElement.classList.add(this.settings.labelElement.className);
      }

      if (this.selectElement.disabled) {
        this.labelElement.classList.add(this.settings.labelElement.disabledClassName);
      } // Move label inside the container


      this.containerElement.appendChild(this.labelElement);
    }
    /**
     * Create a button element to essentially replace the UI of the native select element.
     *
     * @return {HTMLButtonElement}
     * @memberof MirrorSelect
     */

  }, {
    key: "createButtonElement",
    value: function createButtonElement() {
      var _this15 = this;

      var buttonElement = document.createElement('button'),
          innerContainerElement = document.createElement('div'); // Set type to "button", to not submit form if contained by one

      buttonElement.type = 'button'; // Create and set an ID for the button

      var buttonElementId = this.getUniqueElementId("".concat(this.settings.buttonElement.idPrefix, "-").concat(this.selectElement.id || this.selectElement.name));
      buttonElement.id = buttonElementId;
      buttonElement.classList.add(this.settings.buttonElement.className);
      innerContainerElement.classList.add(this.settings.innerContainerElement.className);
      buttonElement.setAttribute('aria-haspopup', 'listbox'); // If an label exists, indicate that it labels the button too

      if (this.labelElement) {
        buttonElement.setAttribute('aria-labelledby', "".concat(this.labelElement.id, " ").concat(buttonElementId));
      } // Match disabled attribute of native select


      buttonElement.disabled = this.selectElement.disabled; // Set button text content from the settings

      var spanElement = document.createElement('span');
      var textNode = document.createTextNode(this.settings.buttonElement.showPlaceholder ? this.settings.buttonElement.textContent : '');
      spanElement.appendChild(textNode);
      buttonElement.appendChild(spanElement);
      buttonElement.setAttribute('data-placeholder', this.settings.buttonElement.textContent);
      buttonElement.addEventListener('click', function () {
        return _this15.onButtonElementClick();
      }); // Insert inner container just after the select, and insert button in it

      this.containerElement.insertBefore(innerContainerElement, this.selectElement.nextSibling);
      innerContainerElement.appendChild(buttonElement);
      return buttonElement;
    }
    /**
     * Create an unordered list element for the options of the custom select.
     *
     * @return {HTMLUListElement}
     * @memberof MirrorSelect
     */

  }, {
    key: "createOptionsListElement",
    value: function createOptionsListElement() {
      var _this16 = this;

      var optionsListElement = document.createElement('ul');
      optionsListElement.classList.add(this.settings.listElement.className);

      if (this.selectElement.multiple) {
        optionsListElement.classList.add(this.settings.listElement.multipleClassName);
      } // Set option list hidden at first


      this.toggleVisibility(optionsListElement, true); // Enable programmatical focusability

      optionsListElement.tabIndex = -1;
      optionsListElement.setAttribute('role', 'listbox'); // Set option list labelled by the label element, if one exists

      if (this.labelElement) {
        optionsListElement.setAttribute('aria-labelledby', this.labelElement.id);
      } // Set size as a CSS variable, to later calculate option list max height


      if (this.settings.setCssProperties) optionsListElement.style.setProperty('--list-size', this.settings.listElement.size); // Add event listeners

      optionsListElement.addEventListener('click', function (_ref17) {
        var target = _ref17.target;
        return _this16.onOptionsListElementClick(target);
      });
      optionsListElement.addEventListener('blur', function (_ref18) {
        var relatedTarget = _ref18.relatedTarget;
        return _this16.onOptionsListElementBlur(relatedTarget);
      });
      optionsListElement.addEventListener('mouseover', function (event) {
        return _this16.onOptionsListElementMouseover(event);
      }); // Insert option list just after the button

      this.buttonElement.parentNode.insertBefore(optionsListElement, this.buttonElement.nextSibling);
      return optionsListElement;
    }
    /**
     * Create a custom option group list, to mimic an optgroup.
     *
     * @param {HTMLOptGroupElement} optgroup - Optgroup element from native select.
     * @param {referenceNode} [referenceNode=null] - Node to use as reference on insertBefore call.
     * @return {HTMLUListElement} - Option group list element.
     * @memberof MirrorSelect
     */

  }, {
    key: "createOptionsListGroupElement",
    value: function createOptionsListGroupElement(optgroup) {
      var referenceNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      // Create a LI element to contain the group
      var listGroupElement = document.createElement('li');
      listGroupElement.setAttribute('data-group', optgroup.label);
      listGroupElement.classList.add(this.settings.listGroupElement.className); // If optgroup is hidden, set the custom group hidden too

      if (optgroup.hidden) {
        listGroupElement.hidden = true;
      } // Create an UL element to contain the group options


      var listGroupListElement = document.createElement('ul');
      listGroupListElement.classList.add(this.settings.listGroupListElement.className); // Add disabled class to the group list, if original optgroup is disabled

      if (optgroup.disabled) {
        listGroupListElement.classList.add(this.settings.listGroupListElement.disabledClassName);
      } // Copy optgroup label to title the group list element


      listGroupListElement.title = optgroup.label; // Insert option group to the dropdown

      listGroupElement.appendChild(listGroupListElement);
      this.optionsListElement.insertBefore(listGroupElement, referenceNode); // Save option group to class variable

      this.optionsListGroupElements[optgroup.label] = listGroupListElement;
      return listGroupListElement;
    }
    /**
     * Get optgroup by option.
     *
     * @param {HTMLOptionElement} option - Option of which optgroup to get.
     * @return {HTMLOptGroupElement|undefined} Optgroup element, or undefined if option has no optgroup.
     * @memberof MirrorSelect
     */

  }, {
    key: "getOptgroup",
    value: function getOptgroup(option) {
      return option.parentElement.tagName.toLowerCase() === 'optgroup' ? option.parentElement : undefined;
    }
    /**
     * Create an option list item for each option of the native select.
     *
     * @param {HTMLOptionsCollection} [options=this.selectElement.options] - Options of the native select.
     * @return {HTMLLIElement[]} - Array of LI elements to represent the options.
     * @memberof MirrorSelect
     */

  }, {
    key: "createOptionsListItemElements",
    value: function createOptionsListItemElements() {
      var _this17 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.selectElement.options;
      var listItemElements = Array.from(options).map(function (option) {
        return _this17.createOptionsListItemElement(option);
      });
      listItemElements.forEach(function (listItemElement, index) {
        // Get option index and reference node to insert list item at correct position
        var optionIndex = options[index].index,
            referenceNode = _this17.optionsListItemElements[optionIndex] || null,
            optgroup = _this17.getOptgroup(options[index]);

        if (optgroup) {
          // Get or create custom option group element
          var listGroupElement = _this17.optionsListGroupElements[optgroup.label] || _this17.createOptionsListGroupElement(optgroup, referenceNode); // Insert option list item in the correct position in the option group


          listGroupElement.insertBefore(listItemElement, referenceNode && referenceNode.parentElement.parentElement.dataset.group === optgroup.label ? referenceNode : null);
        } else {
          // Insert option list item in the correct position in the option list
          _this17.optionsListElement.insertBefore(listItemElement, referenceNode);
        } // Also insert in a specific index of the array


        _this17.optionsListItemElements.splice(optionIndex, 0, listItemElement);
      });
    }
    /**
     * Create an option list item for an option of the native select.
     *
     * @param {HTMLOptionElement} optionElement - Option of the native select.
     * @return {HTMLLIElement} - LI element to represent the option.
     * @memberof MirrorSelect
     */

  }, {
    key: "createOptionsListItemElement",
    value: function createOptionsListItemElement(optionElement) {
      var optionsListItemElement = document.createElement('li');
      optionsListItemElement.id = this.createOptionsListItemElementId(optionElement.value);
      optionsListItemElement.classList.add(this.settings.listItemElement.className);

      var _iterator = _createForOfIteratorHelper(optionElement.attributes),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var attr = _step.value;
          // Passthru dataset values as such
          if (this.settings.cloneAttributesWhitelist.includes(attr.name) || attr.name.startsWith('data-')) optionsListItemElement.setAttribute(attr.name, attr.value);
        } // Save value of the option in a data attribute

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      optionsListItemElement.setAttribute('data-value', optionElement.value); // Get optgroup, if option belongs to one

      var optgroup = this.getOptgroup(optionElement); // Hide option list item, if the original option or its optgroup is hidden too

      if (optionElement.hidden || optgroup !== null && optgroup !== void 0 && optgroup.hidden) {
        this.toggleVisibility(optionsListItemElement, true);
      } // Add disabled class to list item, if necessary


      if (optionElement.disabled || optgroup !== null && optgroup !== void 0 && optgroup.disabled) {
        optionsListItemElement.classList.add(this.settings.listItemElement.disabledClassName);
      }

      optionsListItemElement.setAttribute('role', 'option'); // Copy text content from the original option to the option list item

      var textNode = document.createTextNode(optionElement.textContent);
      optionsListItemElement.appendChild(textNode); // Pre-select option, if selected attribute is present

      if (optionElement.selected) {
        if (this.selectElement.multiple) {
          this.toggleMultipleSelectOption(optionsListItemElement, true, optionElement);
        } else {
          this.state.focusedOptionsListItem = optionsListItemElement;
          this.toggleSingleSelectOption(optionsListItemElement, true);
        }
      }

      return optionsListItemElement;
    }
    /**
     * Observe attribute and child list mutations on the native select.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "observeSelectElementMutations",
    value: function observeSelectElementMutations() {
      var _this18 = this;

      var observer = new MutationObserver(function (mutations) {
        return _this18.onSelectElementMutation(mutations);
      });
      var attributeFilter = ['disabled', 'hidden'];
      if (this.settings.mirrorNative) attributeFilter.push('selected');
      observer.observe(this.selectElement, {
        attributes: true,
        attributeFilter: attributeFilter,
        subtree: true,
        childList: true
      });
    }
    /**
     * Toggle custom select options list open and closed.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "onButtonElementClick",
    value: function onButtonElementClick() {
      !this.state.isOptionsListOpen ? this.openOptionsList() : this.closeOptionsList();
    }
    /**
     * Visually focus and toggle selections of option list items on click.
     *
     * @param {Object} target - Click event target.
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptionsListElementClick",
    value: function onOptionsListElementClick(target) {
      if (target.getAttribute('role') === 'option') {
        this.focusOptionsListItem(target);

        if (this.selectElement.multiple) {
          this.toggleMultipleSelectOption(target);
        } else {
          this.toggleSingleSelectOption(target);
          this.closeOptionsList();
        }

        if (this.settings.mirrorNative) {
          this.selfTriggered = true; // prevent looping results: mutation observer will know not to act on these, since they are self-triggered mutations.

          this.findMatchingNativeOption(target).toggleAttribute('selected');
        }
      }
    }
    /**
     * Respond to keyboard navigation on the custom select container element.
     *
     * @param {Event} event - Keydown event.
     * @memberof MirrorSelect
     */

  }, {
    key: "onContainerElementKeydown",
    value: function onContainerElementKeydown(event) {
      switch (event.key) {
        case 'PageUp':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(-this.settings.listElement.size + 1), true) : this.openOptionsList();
          break;

        case 'PageDown':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(this.settings.listElement.size - 1), true) : this.openOptionsList();
          break;

        case 'Up':
        case 'ArrowUp':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(-1), true) : this.openOptionsList();
          break;

        case 'Down':
        case 'ArrowDown':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(1), true) : this.openOptionsList();
          break;

        case 'Home':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(0, 0), true) : this.openOptionsList();
          break;

        case 'End':
          event.preventDefault();
          this.shouldFocusOnOption() ? this.focusOptionsListItem(this.getClosestFocusableOptionListItem(0, this.optionsListItemElements.length - 1), true) : this.openOptionsList();
          break;

        case ' ':
        case 'Spacebar':
          if (this.state.isOptionsListOpen) {
            event.preventDefault();

            if (this.selectElement.multiple && this.state.focusedOptionsListItem) {
              this.toggleMultipleSelectOption(this.state.focusedOptionsListItem);
            }
          }

          break;

        case 'Enter':
        case 'Esc':
        case 'Escape':
          if (this.state.isOptionsListOpen) {
            event.preventDefault();
            this.closeOptionsList();
          }

          break;

        default:
          // TODO: Search for item to focus by input
          break;
      }
    }
    /**
     * Close options list on blur.
     *
     * @param {EventTarget} relatedTarget
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptionsListElementBlur",
    value: function () {
      var _onOptionsListElementBlur2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(relatedTarget) {
        var elementReceivingFocus;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = relatedTarget;

                if (_context2.t0) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return new Promise(function (resolve) {
                  setTimeout(function () {
                    return resolve(document.activeElement);
                  });
                });

              case 4:
                _context2.t0 = _context2.sent;

              case 5:
                elementReceivingFocus = _context2.t0;

                // Close options list only if the element receiving focus is not inside the custom select container
                if (!elementReceivingFocus || !this.containerElement.contains(elementReceivingFocus)) {
                  this.closeOptionsList();
                }

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onOptionsListElementBlur(_x2) {
        return _onOptionsListElementBlur2.apply(this, arguments);
      }

      return onOptionsListElementBlur;
    }()
    /**
     * Focus visually on option list item on mouseover.
     *
     * @param {Event} event - Mouseover event.
     * @param {Object} event.target - Event target.
     * @param {number} event.clientX - Horizontal coordinate in the viewport.
     * @param {number} event.clientY - Vertical coordinate in the viewport.
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptionsListElementMouseover",
    value: function onOptionsListElementMouseover(_ref19) {
      var target = _ref19.target,
          clientX = _ref19.clientX,
          clientY = _ref19.clientY;

      if (target.getAttribute('role') === 'option') {
        // Check that mouse position actually changed
        var isClientXYChanged = clientX - (this.prevMouseEventClientX || 0) || clientY - (this.prevMouseEventClientY || 0);

        if (isClientXYChanged) {
          this.focusOptionsListItem(target);
          this.prevMouseEventClientX = clientX;
          this.prevMouseEventClientY = clientY;
        }
      }
    }
    /**
     * Close options list if it's open, and a click occurred outside of the container element.
     *
     * @param {Object} target - Click event target.
     * @memberof MirrorSelect
     */

  }, {
    key: "onDocumentClick",
    value: function onDocumentClick(target) {
      if (this.state.isOptionsListOpen && !this.containerElement.contains(target)) {
        this.closeOptionsList();
      }
    }
    /**
     * Update selected options from native select to custom select on change.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "onSelectElementChange",
    value: function onSelectElementChange() {
      var _this19 = this;

      var selectedOptionsArray = Array.from(this.selectElement.selectedOptions);
      this.optionsListItemElements.forEach(function (listItem) {
        var isCustomOptionSelected = listItem.classList.contains(_this19.settings.listItemElement.selectedClassName),
            isNativeOptionSelected = selectedOptionsArray.some(function (_ref20) {
          var value = _ref20.value;
          return value === listItem.dataset.value;
        });

        if (isCustomOptionSelected) {
          if (!isNativeOptionSelected) {
            _this19.selectElement.multiple ? _this19.toggleMultipleSelectOption(listItem, true) : _this19.toggleSingleSelectOption(_this19.getFirstFocusableOptionsListItem(false, true), true);
          }
        } else if (isNativeOptionSelected) {
          _this19.selectElement.multiple ? _this19.toggleMultipleSelectOption(listItem, true) : _this19.toggleSingleSelectOption(listItem, true);
        }
      });
    }
    /**
     * Mirror mutations of the native select to the custom select.
     *
     * @param {MutationRecord[]} mutations
     * @memberof MirrorSelect
     */

  }, {
    key: "onSelectElementMutation",
    value: function onSelectElementMutation(mutations) {
      var _this20 = this;

      if (this.selfTriggered) return this.selfTriggered = false;
      mutations.forEach(function (mutation) {
        var type = mutation.type,
            target = mutation.target,
            attributeName = mutation.attributeName;

        if (type === 'childList') {
          _this20.onSelectElementChildListMutation(mutation);
        } else if (type === 'attributes') {
          var targetTagName = target.tagName.toLowerCase();

          if (attributeName === 'selected' && targetTagName === 'option') {
            _this20.toggleSelectOption(target, true);
          } else if (attributeName === 'disabled') {
            if (targetTagName === 'select') {
              _this20.onSelectElementDisabledMutation();
            } else if (targetTagName === 'option') {
              _this20.onOptionElementDisabledMutation(target);
            } else if (targetTagName === 'optgroup') {
              _this20.onOptgroupElementDisabledMutation(target);
            }
          } else if (attributeName === 'hidden') {
            if (targetTagName === 'select') {
              _this20.onSelectElementHiddenMutation();
            } else if (targetTagName === 'option') {
              _this20.onOptionElementHiddenMutation(target);
            } else if (targetTagName === 'optgroup') {
              _this20.onOptgroupElementHiddenMutation(target);
            }
          }
        }
      });
    }
    /**
     * Add or remove option list items on mutation of the child list of the native select.
     *
     * @param {MutationRecord} mutation - DOM mutation of the native select.
     * @param {NodeList} mutation.addedNodes - List of added nodes.
     * @param {NodeList} mutation.removedNodes - List of removed nodes.
     * @memberof MirrorSelect
     */

  }, {
    key: "onSelectElementChildListMutation",
    value: function onSelectElementChildListMutation(_ref21) {
      var _this21 = this;

      var addedNodes = _ref21.addedNodes,
          removedNodes = _ref21.removedNodes;
      var addedOptions = this.filterNodeListByConstructor(addedNodes, HTMLOptionElement),
          removedOptions = this.filterNodeListByConstructor(removedNodes, HTMLOptionElement); // If any options added to native select, also add them to custom select

      if (addedOptions.length) {
        this.createOptionsListItemElements(addedOptions);
      } // Same goes for removed options


      if (removedOptions.length) {
        removedOptions.forEach(function (removedOption) {
          var correspondingListItemIndex = _this21.optionsListItemElements.findIndex(function (_ref22) {
            var value = _ref22.dataset.value;
            return value === removedOption.value;
          });

          var correspondingListItem = _this21.optionsListItemElements[correspondingListItemIndex];

          if (correspondingListItem) {
            // If removed option was selected, unselect it from the custom select
            if (removedOption.selected) {
              if (_this21.selectElement.multiple) {
                removedOption.selected = false;

                _this21.toggleMultipleSelectOption(correspondingListItem, true, removedOption);
              } else {
                _this21.toggleSingleSelectOption(correspondingListItem, true, '');
              }
            } // Remove option list item


            correspondingListItem.parentElement.removeChild(correspondingListItem);

            _this21.optionsListItemElements.splice(correspondingListItemIndex, 1);
          }
        });
      }
    }
    /**
     * Toggle disabled state of custom select on mutation of native select disabled attribute.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "onSelectElementDisabledMutation",
    value: function onSelectElementDisabledMutation() {
      if (this.selectElement.disabled && this.state.isOptionsListOpen) {
        this.closeOptionsList();
      }

      if (this.labelElement) {
        if (this.selectElement.disabled) {
          this.labelElement.classList.add(this.settings.labelElement.disabledClassName);
        } else {
          this.labelElement.classList.remove(this.settings.labelElement.disabledClassName);
        }
      }

      this.buttonElement.disabled = this.selectElement.disabled;
    }
    /**
     * Toggle hidden state of custom select on mutation of native select hidden attribute.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "onSelectElementHiddenMutation",
    value: function onSelectElementHiddenMutation() {
      if (this.selectElement.hidden && this.state.isOptionsListOpen) {
        this.closeOptionsList();
      }

      this.containerElement.hidden = this.selectElement.hidden;
    }
    /**
     * Toggle disabled state of custom option on mutation of native option disabled attribute.
     *
     * @param {HTMLOptionElement} option - Mutated option element.
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptionElementDisabledMutation",
    value: function onOptionElementDisabledMutation(option) {
      var optionsListItem = this.findMatchingOptionsListItem(option);
      optionsListItem.classList.toggle(this.settings.listItemElement.disabledClassName, option.disabled);
    }
    /**
     * Toggle hidden state of custom option on mutation of native option hidden attribute.
     *
     * @param {HTMLOptionElement} option - Mutated option element.
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptionElementHiddenMutation",
    value: function onOptionElementHiddenMutation(option) {
      var optionsListItem = this.findMatchingOptionsListItem(option);
      this.toggleVisibility(optionsListItem, option.hidden);
    }
    /**
     * Toggle disabled state of custom optgroup on mutation of native optgroup disabled attribute.
     *
     * @param {HTMLOptGroupElement} optgroup - Mutated optgroup element.
     * @param {string} optgroup.label - Label of optgroup.
     * @param {boolean} optgroup.disabled - Disabled attribute of optgroup.
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptgroupElementDisabledMutation",
    value: function onOptgroupElementDisabledMutation(_ref23) {
      var _this22 = this;

      var label = _ref23.label,
          disabled = _ref23.disabled;
      var listGroup = this.optionsListGroupElements[label];
      listGroup.classList.toggle(this.settings.listGroupListElement.disabledClassName, disabled);
      Array.from(listGroup.children).forEach(function (listItem) {
        listItem.classList.toggle(_this22.settings.listGroupListElement.disabledClassName, disabled);
      });
    }
    /**
     * Toggle hidden state of custom optgroup on mutation of native optgroup hidden attribute.
     *
     * @param {HTMLOptGroupElement} optgroup - Mutated optgroup element.
     * @param {string} optgroup.label - Label of optgroup.
     * @param {boolean} optgroup.hidden - Hidden attribute of optgroup.
     * @memberof MirrorSelect
     */

  }, {
    key: "onOptgroupElementHiddenMutation",
    value: function onOptgroupElementHiddenMutation(_ref24) {
      var label = _ref24.label,
          hidden = _ref24.hidden;
      this.optionsListGroupElements[label].parentElement.hidden = hidden;
      Array.from(this.optionsListGroupElements[label].children).forEach(function (listItem) {
        listItem.hidden = hidden;
      });
    }
    /**
     * Open custom select options list.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "openOptionsList",
    value: function openOptionsList() {
      if (!this.state.isOptionsListOpen) {
        // Set item height CSS variable, if it is not set yet
        if (!this.state.isItemHeightCSSVariableSet) {
          this.setItemHeightCSSVariable();
        }

        this.state.isOptionsListOpen = true;
        this.toggleVisibility(this.optionsListElement, false);
        this.buttonElement.setAttribute('aria-expanded', 'true');
        this.containerElement.classList.add(this.settings.containerElement.classNameOpen);
        this.optionsListElement.focus(this.settings.listElement.preventScrollOnFocus ? {
          preventScroll: true
        } : {});

        if (this.state.focusedOptionsListItem) {
          this.optionsListElement.setAttribute('aria-activedescendant', this.state.focusedOptionsListItem.id);
        } else if (this.optionsListItemElements.length) {
          this.focusOptionsListItem(this.getFirstFocusableOptionsListItem(false, true));
        }
      }
    }
    /**
     * Close custom select options list.
     *
     * @memberof MirrorSelect
     */

  }, {
    key: "closeOptionsList",
    value: function closeOptionsList() {
      if (this.state.isOptionsListOpen) {
        this.state.isOptionsListOpen = false;
        this.toggleVisibility(this.optionsListElement, true);
        this.buttonElement.removeAttribute('aria-expanded');
        this.containerElement.classList.remove(this.settings.containerElement.classNameOpen);
        this.buttonElement.focus(this.settings.buttonElement.preventScrollOnFocus ? {
          preventScroll: true
        } : {});
        this.optionsListElement.removeAttribute('aria-activedescendant');

        if (this.state.focusedOptionsListItem && this.selectElement.multiple) {
          this.state.focusedOptionsListItem.classList.remove(this.settings.listItemElement.focusClassName);
          this.state.focusedOptionsListItem = undefined;
        }
      }
    }
    /**
     * Toggle selection of an option of a single-select.
     *
     * @param {Object} target - Toggled option list item.
     * @param {boolean} isPreSelect - Toggled through pre-selection ("selected" attribute).
     * @param {string} [value=target.dataset.value] - Value of option list item.
     * @return {undefined}
     * @memberof MirrorSelect
     */

  }, {
    key: "toggleSingleSelectOption",
    value: function toggleSingleSelectOption(target) {
      var _this23 = this;

      var isPreSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : target.dataset.value;

      if (!isPreSelect) {
        // Return if tried to toggle selected option
        if (value && value === this.selectElement.value) {
          return;
        } // Set value of the native select


        this.selectElement.value = value; // Dispatch change event

        this.selectElement.dispatchEvent(new CustomEvent('change', {
          bubbles: true,
          detail: {
            dispatcher: 'multiselect'
          }
        }));
      } // Show the default text content of the button above the selected options


      this.buttonElement.classList.toggle(this.settings.buttonElement.placeholderClassName, !!value);
      this.buttonElement.toggleAttribute('data-selected', !!value); // Update custom select UI depending on if the selected option has a value or not

      if (value) {
        // Set text content of the button to match the selected option list item
        this.buttonElement.firstElementChild.textContent = target.textContent;
        this.buttonElement.firstElementChild.setAttribute('data-label-for', target.id);
      } else {
        // Reset text content of the button to the default one
        this.buttonElement.firstElementChild.textContent = this.settings.buttonElement.showPlaceholder ? this.settings.buttonElement.textContent : target.textContent;
        this.buttonElement.firstElementChild.removeAttribute('data-label-for');
      } // Remove selected class and "aria-selected" attribute from previously selected option


      if (this.optionsListItemElements) {
        this.optionsListItemElements.forEach(function (listItem) {
          listItem.classList.remove(_this23.settings.listItemElement.selectedClassName);
          listItem.removeAttribute('aria-selected');
        });
      } // Add selected class and "aria-selected" attribute on the selected option


      target.classList.add(this.settings.listItemElement.selectedClassName);
      target.setAttribute('aria-selected', 'true');
    }
    /**
     * Toggle selection of an option of a multiselect.
     *
     * @param {Object} target - Toggled option list item.
     * @param {boolean} isPreSelect - Toggled through pre-selection ("selected" attribute).
     * @param {HTMLOptionElement} [targetNativeOption=this.findMatchingNativeOption(target)] - Corresponding native option.
     * @memberof MirrorSelect
     */

  }, {
    key: "toggleMultipleSelectOption",
    value: function toggleMultipleSelectOption(target) {
      var isPreSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var targetNativeOption = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.findMatchingNativeOption(target);

      if (!isPreSelect) {
        // Toggle selection of native option
        targetNativeOption.selected = !targetNativeOption.selected; // Dispatch change event

        this.selectElement.dispatchEvent(new CustomEvent('change', {
          bubbles: true,
          detail: {
            dispatcher: 'multiselect'
          }
        }));
      } // Update custom select UI accordingly


      if (targetNativeOption.selected) {
        target.classList.add(this.settings.listItemElement.selectedClassName);
        target.setAttribute('aria-selected', 'true');

        if (target.dataset.value) {
          // Show the default text content of the button above the selected options
          if (this.settings.buttonElement.showPlaceholder) {
            this.buttonElement.classList.add(this.settings.buttonElement.placeholderClassName);
          } // Reset text content of the button, if only the default value is shown


          if (this.buttonElement.firstElementChild.textContent === this.settings.buttonElement.textContent) {
            this.buttonElement.firstElementChild.textContent = '';
          } // Set selected data attribute, mainly for easier styling


          if (!this.buttonElement.hasAttribute('data-selected')) {
            this.buttonElement.setAttribute('data-selected', '');
          } // Create a span element for the selected option


          var spanElement = document.createElement('span'),
              textNode = document.createTextNode(target.textContent);
          spanElement.setAttribute('data-label-for', target.id);
          spanElement.appendChild(textNode); // Add the span element with the text content of the selected option to the button

          this.buttonElement.firstElementChild.appendChild(spanElement);
        }
      } else {
        target.classList.remove(this.settings.listItemElement.selectedClassName);
        target.removeAttribute('aria-selected'); // Find the span element that represents the unselected option

        var _spanElement2 = Array.from(this.buttonElement.firstElementChild.children).find(function (_ref25) {
          var labelFor = _ref25.dataset.labelFor;
          return labelFor === target.id;
        }); // Remove the matching span element, if found


        if (_spanElement2) {
          this.buttonElement.firstElementChild.removeChild(_spanElement2);
        } // Hide the "placeholder" text, if the last selected option was just unselected


        if (!this.buttonElement.firstElementChild.children.length) {
          if (this.settings.buttonElement.showPlaceholder) {
            this.buttonElement.classList.remove(this.settings.buttonElement.placeholderClassName);
          } // Reset text content of the button to the default one


          this.buttonElement.firstElementChild.textContent = this.settings.buttonElement.showPlaceholder ? this.settings.buttonElement.textContent : '';
          this.buttonElement.removeAttribute('data-selected');
        }
      }
    }
  }, {
    key: "toggleSelectOption",
    value: function toggleSelectOption(target) {
      var isPreSelect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.selectElement.multiple) {
        this.toggleMultipleSelectOption(this.findMatchingOptionsListItem(target), isPreSelect, target);
      } else {
        this.toggleSingleSelectOption(target, isPreSelect, target.dataset.value);
      }
    }
    /**
     * Set visual focus only to target option list item.
     *
     * @param {Object} target - Option list item to visually focus.
     * @param {boolean} [isTriggeredByKey=false] - Is focus triggered through keyboard nagivation.
     * @return {undefined}
     * @memberof MirrorSelect
     */

  }, {
    key: "focusOptionsListItem",
    value: function focusOptionsListItem(target) {
      var isTriggeredByKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!target) {
        return;
      }

      if (this.state.focusedOptionsListItem) {
        this.state.focusedOptionsListItem.classList.remove(this.settings.listItemElement.focusClassName);
      }

      this.state.focusedOptionsListItem = target;
      target.classList.add(this.settings.listItemElement.focusClassName);

      if (isTriggeredByKey) {
        this.optionsListElement.setAttribute('aria-activedescendant', target.id); // Scroll to target, if it's off-screen

        this.scrollToOptionListItemElement(target); // Auto-select option on focus, in the case of a single select, and if focus is triggered by key

        if (!this.selectElement.multiple) {
          this.toggleSingleSelectOption(target);
        }
      }
    }
    /**
     * Scroll to option list item, if it's off-screen.
     *
     * @param {HTMLLIElement} listItem - Option list item of which position to check.
     * @memberof MirrorSelect
     */

  }, {
    key: "scrollToOptionListItemElement",
    value: function scrollToOptionListItemElement(listItem) {
      if (this.optionsListElement.scrollHeight > this.optionsListElement.clientHeight) {
        var listItemBottom = listItem.offsetTop + listItem.offsetHeight,
            scrollBottom = this.optionsListElement.clientHeight + this.optionsListElement.scrollTop;

        if (listItemBottom > scrollBottom) {
          this.optionsListElement.scrollTop = listItemBottom - this.optionsListElement.clientHeight;
        } else if (listItem.offsetTop < this.optionsListElement.scrollTop) {
          this.optionsListElement.scrollTop = listItem.offsetTop;
        }
      }
    }
    /**
     * Get a boolean value whether to visually focus on an option list item, or not.
     *
     * @return {boolean}
     * @memberof MirrorSelect
     */

  }, {
    key: "shouldFocusOnOption",
    value: function shouldFocusOnOption() {
      return this.state.isOptionsListOpen || !this.selectElement.multiple;
    }
    /**
     * Get closest focusable option list item by offset.
     *
     * @param {number} offset - Offset to add to index.
     * @param {number} [index=this.getFocusedOptionIndex()] - Index of option list item.
     * @return {HTMLLIElement|undefined} Closest option list item to focus, or undefined if none found.
     * @memberof MirrorSelect
     */

  }, {
    key: "getClosestFocusableOptionListItem",
    value: function getClosestFocusableOptionListItem(offset) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getFocusedOptionIndex();
      var targetIndex = index + offset; // If target index is equal or less than 0, return first focusable option list item

      if (targetIndex <= 0) {
        return this.getFirstFocusableOptionsListItem();
      } // If target index is equal or larger than last index of array, return last focusable option list item


      if (targetIndex >= this.optionsListItemElements.length - 1) {
        return this.getLastFocusableOptionsListItem();
      } // Else if offset is falsy (0), there's nothing to do


      if (!offset) {
        return this.state.focusedOptionsListItem;
      }

      var targetOptionsListItem = this.optionsListItemElements[targetIndex]; // Check if target is hidden or disabled

      if (targetOptionsListItem.hidden || targetOptionsListItem.classList.contains(this.settings.listItemElement.disabledClassName)) {
        // If so, recursively check next or previous option list item, based on whether offset is positive or negative
        return this.getClosestFocusableOptionListItem(offset + Math.sign(offset), index);
      }

      return targetOptionsListItem;
    }
    /**
     * Get index of the visually focused option list item.
     *
     * @return {number|undefined} - Index, or undefined if no option list item is focused.
     * @memberof MirrorSelect
     */

  }, {
    key: "getFocusedOptionIndex",
    value: function getFocusedOptionIndex() {
      return this.state.focusedOptionsListItem && this.optionsListItemElements.indexOf(this.state.focusedOptionsListItem);
    }
    /**
     * Create an ID for the option list item.
     *
     * @param {string} value - Value of an option of the native select.
     * @return {string}
     * @memberof MirrorSelect
     */

  }, {
    key: "createOptionsListItemElementId",
    value: function createOptionsListItemElementId(value) {
      return this.getUniqueElementId("".concat(this.settings.listItemElement.idPrefix, "-").concat(value ? value.toLowerCase().replace(/\s/, '-') : 'empty'));
    }
    /**
     * Set option list item height to a CSS variable for the option list element.
     *
     * @return {undefined}
     * @memberof MirrorSelect
     */

  }, {
    key: "setItemHeightCSSVariable",
    value: function setItemHeightCSSVariable() {
      var firstListItemWithHeight = this.getFirstFocusableOptionsListItem(true, false); // Do nothing, if could not find an option list item

      if (!firstListItemWithHeight) {
        return;
      } // Unhide option list element temporarily (not visually though) to get the height of its child


      this.optionsListElement.style.height = '0';
      this.optionsListElement.style.border = '0';
      this.optionsListElement.style.overflowY = 'hidden';
      this.optionsListElement.hidden = false; // Check if list item is contained by a hidden group

      var listItemGroup = firstListItemWithHeight.parentElement.parentElement.classList.contains(this.settings.listGroupElement.className) && firstListItemWithHeight.parentElement.parentElement;
      var isListItemGroupHidden = listItemGroup === null || listItemGroup === void 0 ? void 0 : listItemGroup.hidden; // If so, unhide the group too

      if (isListItemGroupHidden) {
        listItemGroup.hidden = false;
      } // Save list item scroll height


      var listItemHeight = firstListItemWithHeight.scrollHeight; // Hide group again

      if (isListItemGroupHidden) {
        listItemGroup.hidden = true;
      } // Hide option list element again


      this.optionsListElement.hidden = true;
      this.optionsListElement.style.removeProperty('height');
      this.optionsListElement.style.removeProperty('border');
      this.optionsListElement.style.removeProperty('overflow-y'); // Do nothing, if option list item has no scroll height

      if (!listItemHeight) {
        return;
      } // Otherwise set the CSS variable


      if (this.settings.setCssProperties) this.optionsListElement.style.setProperty('--item-height', "".concat(listItemHeight, "px")); // Update state to not set item height CSS variable again

      this.state.isItemHeightCSSVariableSet = true;
    }
    /**
     * Get first label element associated with the select element.
     *
     * @param {HTMLSelectElement} selectElement - Native select element.
     * @param {NodeList|undefined} selectElement.labels - Label elements associated with select element.
     * @param {string} selectElement.id - ID of select element.
     * @return {HTMLLabelElement|undefined|null}
     * @memberof MirrorSelect
     */

  }, {
    key: "getAssociatedLabel",
    value: function getAssociatedLabel(_ref26) {
      var labels = _ref26.labels,
          id = _ref26.id;
      return labels ? labels[0] : document.querySelector("label[for=\"".concat(id, "\"]"));
    }
    /**
     * Toggle hidden and aria-hidden attributes of an element.
     *
     * @param {HTMLElement} element - Any HTML element.
     * @param {boolean} [shouldHide=!element.hidden] - Hide or show element.
     * @memberof MirrorSelect
     */

  }, {
    key: "toggleVisibility",
    value: function toggleVisibility(element) {
      var shouldHide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !element.hidden;
      element.hidden = shouldHide;

      if (shouldHide) {
        element.setAttribute('aria-hidden', 'true');
      } else {
        element.removeAttribute('aria-hidden');
      }
    }
    /**
     * Get first focusable option list item.
     *
     * @param {boolean} [checkHidden=true] - Whether to check option list item class list for truthy hidden attribute.
     * @param {boolean} [checkDisabled=true] - Whether to check option list item class list for disabled class.
     * @return {HTMLLIElement|undefined} - First focusable option list item, or undefined if not found.
     * @memberof MirrorSelect
     */

  }, {
    key: "getFirstFocusableOptionsListItem",
    value: function getFirstFocusableOptionsListItem() {
      var _this24 = this;

      var checkHidden = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var checkDisabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.optionsListItemElements.find(function (listItem) {
        return (!checkHidden || !listItem.hidden) && (!checkDisabled || !listItem.classList.contains(_this24.settings.listItemElement.disabledClassName));
      });
    }
    /**
     * Get last focusable option list item.
     *
     * @return {HTMLLIElement|undefined} - Last focusable option list item, or undefined if not found.
     * @memberof MirrorSelect
     */

  }, {
    key: "getLastFocusableOptionsListItem",
    value: function getLastFocusableOptionsListItem() {
      var lastFocusableListItem;

      for (var index = this.optionsListItemElements.length - 1; index >= 0; index--) {
        if (!this.optionsListItemElements[index].hidden && !this.optionsListItemElements[index].classList.contains(this.settings.listItemElement.disabledClassName)) {
          lastFocusableListItem = this.optionsListItemElements[index];
          break;
        }
      }

      return lastFocusableListItem;
    }
    /**
     * Find option from the native select that matches a given option list item.
     *
     * @param {HTMLLIElement} optionListItem - Option list item from the custom select.
     * @return {HTMLOptionElement} - Corresponding option from the native select.
     * @memberof MirrorSelect
     */

  }, {
    key: "findMatchingNativeOption",
    value: function findMatchingNativeOption(optionListItem) {
      return Array.from(this.selectElement.options).find(function (_ref27) {
        var value = _ref27.value;
        return value === optionListItem.dataset.value;
      });
    }
    /**
     * Find option list item that matches a given option from the native select.
     *
     * @param {HTMLOptionElement} option - Native option element.
     * @return {HTMLLIElement} - Corresponding option list item from the custom select.
     * @memberof MirrorSelect
     */

  }, {
    key: "findMatchingOptionsListItem",
    value: function findMatchingOptionsListItem(option) {
      return this.optionsListItemElements.find(function (_ref28) {
        var value = _ref28.dataset.value;
        return value === option.value;
      });
    }
    /**
     * Filter node list by constructor.
     *
     * @param {NodeList} nodeList - Node list to filter.
     * @param {Object} constructor - Object to test against.
     * @return {Array} - Array of filtered nodes.
     * @memberof MirrorSelect
     */

  }, {
    key: "filterNodeListByConstructor",
    value: function filterNodeListByConstructor(nodeList, constructor) {
      return nodeList.length ? Array.from(nodeList).filter(function (node) {
        return node instanceof constructor;
      }) : [];
    }
    /**
     * Check element ID is unique, and if not, iterate until one is found, and return the ID suffixed with index.
     *
     * @param {string} id - Element ID to test.
     * @param {number} [index=0] - Index to suffix the ID with.
     * @return {string} - Unique element ID.
     * @memberof MirrorSelect
     */

  }, {
    key: "getUniqueElementId",
    value: function getUniqueElementId(id) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var idToTest = index ? "".concat(id, "-").concat(index) : id;

      if (document.getElementById(idToTest)) {
        return this.getUniqueElementId(id, index + 1);
      }

      return idToTest;
    }
  }]);
  return MirrorSelect;
}();

exports.MirrorSelect = MirrorSelect;